export const SALUTATIONS = ['Sr.', 'Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Prof.']

export const CASE_STATUS = ['New', 'Working', 'Escalated', 'Resolved', 'Closed']

export const CASE_ORIGIN = ['Email', 'Teléfono', 'Web']

export const CASE_PRIORITY = ['Low', 'Medium', 'High', 'Media']

export const LEAD_STATUS = ['Nuevo', 'Contactado', 'Nurturing', 'No cualificado', 'Converted']

export const TASK_STATUS = ['Not Started', 'In Progress', 'Completed']

export const TASK_PRIORITY = ['Low', 'Medium', 'High']

export const OPPORTUNITY_STAGE = [
  'Prospecting',
  'Qualification',
  'Proposal',
  'Negotiation',
  'Closed Won',
  'Closed Lost',
]

export const OWNERS = [
  'Sarah Johnson',
  'Michael Chen',
  'Emily Rodriguez',
  'James Wilson',
  'Patricia Lee',
]
